export default __webpack_public_path__ + "static/media/car.8e7adccd.wav";